<template>
  <div>
    <div class="typeNav">
      <div class="typeNav-container" style="border-radius: 8px 8px 0px 0px;">
        <ul class="typeNav-box">
          <div
            v-for="(item,index) in typeNavList"
            :key="index"
            @mouseenter="enterHandler(index)"
            @mouseleave="leaveHandler"
          >
            <li
              :class="{ active: typeNavIndex == index }"
              @click="chooseType(item,index)"
              v-if="!item.pageLink
"
            >
              <a>{{item.primaryColName}}</a>
            </li>
            <li :class="{ active: typeNavIndex == index }" v-else>
              <a :href="item.pageLink" target="_blank" rel="noopenner noreferrer">{{item.primaryColName}}</a>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  //给组件起一个名字,开发者工具中显示这个组件的时候，显示的就是这个名字
  // eslint-disable-next-line vue/multi-word-component-names
  name: "typeNav",
  //计算属性
  computed: {
    ...mapState({
      typeNavList: state => state.home.typeNavList //对象简写形式
    })
  },
  data() {
    return {
      //收集用户输入的关键字
      typeNavIndex: -1
      // typeNavList: [
      // "首页",
      // "通知公告",
      // "学会工作",
      // "教研评审",
      // "会员风采",
      // "职教动态",
      // "招生培训",
      // "升学就业"
      // ]
    };
  },
  mounted() {
    // if (this.$route.params.primaryColName) {
    //   this.typeNavList.forEach((x, y) => {
    //     if (x.primaryColName == this.$route.params.primaryColName) {
    //       this.typeNavIndex = y;
    //     }
    //   });
    // } else if (this.$route.path == "/home") {
    //   this.typeNavIndex = 0;
    // } else {
    //   this.typeNavIndex = -1;
    // }
  },
  methods: {
    enterHandler(index) {
      this.typeNavIndex = index;
    },
    leaveHandler() {
      this.typeNavIndex = -1;
      // if (this.$route.params.primaryColName) {
      //   this.typeNavList.forEach((x, y) => {
      //     if (x.primaryColName == this.$route.params.primaryColName) {
      //       this.typeNavIndex = y;
      //     }
      //   });
      // } else if (this.$route.path == "/home") {
      //   this.typeNavIndex = 0;
      // } else {
      //   this.typeNavIndex = -1;
      // }
    },
    chooseType(item, index) {
      // console.log(item);
      if (index == 0) {
        if (this.$route.path === "/home") {
          // 检查当前是否在首页
          this.$router.go(); // 刷新页面
        } else {
          this.$router.push("/home"); // 如果不在首页，跳转到首页
        }
      } else {
        this.$router.push({
          name: "通知公告",
          params: { primaryColName: item.primaryColName },
          query: { id: item.id }
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.typeNav {
  .typeNav-container {
    width: 1200px;
    margin: 0 auto;
    background: #1286c4;
    .typeNav-box {
      display: flex;
      // align-items: center;
      // justify-content: center;
      li {
        // background: #1286c4;
        width: 150px;
        height: 64px;
        // line-height: 64px;
        // text-align: center;
        cursor: pointer;
        a {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          text-decoration: none;
        }
      }
      .active {
        background: #fff;
        a {
          color: #1286c4 !important;
        }
      }
    }
  }
}
@media only screen and (min-width: 993px) {
  .typeNav {
    .typeNav-container {
      width: 1200px;
      margin: 0 auto;
      background: #1286c4;
      .typeNav-box {
        display: flex;
        // align-items: center;
        // justify-content: center;
        li {
          // background: #1286c4;
          width: 150px;
          height: 64px;
          // line-height: 64px;
          // text-align: center;
          cursor: pointer;
          a {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            text-decoration: none;
          }
        }
        .active {
          background: #fff;
          a {
            color: #1286c4 !important;
          }
        }
      }
    }
  }
}
</style>
